import React, { useState, useEffect } from 'react';
import CaseStudyLevel1 from './CaseStudy/CaseStudyLevel1';
import CaseStudyLevel2 from './CaseStudy/CaseStudyLevel2';
import CaseStudyLevel3 from './CaseStudy/CaseStudyLevel3';
import './CaseStudy/CaseStudy.css';

const LEVELS = ['Network Summary', 'Spatial/Zone Analysis', 'Bottleneck Analysis'];

function AnalysisResultPage() {
  const [activeLevel, setActiveLevel] = useState('Network Summary');
  const [data, setData] = useState(null);
  const [scenario, setScenario] = useState('');

  useEffect(() => {
    const stored = localStorage.getItem('macroAnalysisResult');
    const storedScenario = localStorage.getItem('macroAnalysisScenario');
    if (stored) {
      setData(JSON.parse(stored));
      setScenario(storedScenario || 'congestion-pricing');
    }
  }, []);

  if (!data) {
    return (
      <div style={{ color: '#fff', padding: 40, background: '#1a1a1a', height: '100vh', fontFamily: 'Inter, sans-serif' }}>
        No analysis data found.
      </div>
    );
  }

  const scenarioLabel = scenario === 'school-zones' ? 'School Zones' : 'Congestion Pricing';

  const renderLevel = () => {
    switch (activeLevel) {
      case 'Network Summary': return <CaseStudyLevel1 data={data.level1} scenarioLabel={scenarioLabel} />;
      case 'Spatial/Zone Analysis': return <CaseStudyLevel2 data={data.level2} scenarioLabel={scenarioLabel} />;
      case 'Bottleneck Analysis': return <CaseStudyLevel3 data={data.level3} />;
      default: return null;
    }
  };

  return (
    <div className="case-study-container" style={{ height: '100vh' }}>
      <h1 className="case-study-title">Comparison Analysis Results</h1>

      <div className="case-study-body">
        <div className="case-study-level-tabs">
          {LEVELS.map(level => (
            <button
              key={level}
              className={activeLevel === level ? 'tab-active' : ''}
              onClick={() => setActiveLevel(level)}
            >
              {level}
            </button>
          ))}
        </div>

        <div className="case-study-content">
          {renderLevel()}
        </div>
      </div>
    </div>
  );
}

export default AnalysisResultPage;
